import React from 'react';
import './styles/NotFound.css';

const NotFound = () => (
  <div className="notfound-container">
    <h2 id="notfound-title">404</h2>
    <p>_Page not found_</p>
  </div>
);

export default NotFound;
